module.exports = __webpack_public_path__ + "images/rich_heading/sports/outdoor/icon_615d22e67d92a22f84a260607f819c85.png";